import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import Cookies from "js-cookie";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import {
  ACCESS_TOKEN,
  APP_VERSION,
  COLOR_APP,
  COLOR_TEXT,
  COLOR_WHITE,
  WEB_LANDING_PAGE_URL,
  LINK_SALE_PAGE,
  S3_URL,
  SHOPID,
  SHOP_DATA,
  SHOW_NOTICE_EXPIRED,
  USER_KEY2,
} from "../constants";
import useReactRouter from "use-react-router";
import {
  Badge,
  Button,
  Card,
  Modal,
  Offcanvas,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import Lottie from "react-lottie";
import moment from "moment";
import contactAnimationData from "../image/lottieContact.json";
import Avatar from "@material-ui/core/Avatar";
import { connect } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { FaRegUserCircle, FaPowerOff } from "react-icons/fa";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileArchive,
  faIdCardAlt,
  faSignOutAlt,
  faBars,
  faRightFromBracket,
  faCircleUser,
  faHeadset,
  faPowerOff,
  faClose,
  faGripLinesVertical,
} from "@fortawesome/free-solid-svg-icons";
import { useLazyQuery, useMutation, useQuery, useSubscription } from "@apollo/client";
import { SUBSCRIPTION_SHOP_CUTPOINT } from "../graphql/shop/subscription";
import { SHOP } from "../graphql/shop/queryShop";
import { CONNECT_SHOP_PAGE } from "../graphql/shop/mutation";
import useWindowDimensions from "../helpers/useWindowDimensions";
import { useStore } from "../store";
import { IconContext } from "react-icons";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";

// Redux
import {
  updateFbdata,
  removeFbdata,
  updateFbFeedList,
} from "../redux/fbdata/fbdata.action";
import {
  errorPermissionTitleWithTextSwal,
  errorTitleWithTextSwal,
} from "../helpers/sweetalert";
import useStateRef from "react-usestateref";
import { useInitFbSDK } from "../helpers/fb-hooks";
import ErrorPermissionModal from "../components/ErrorPermissionModal";
import { Link } from "react-router-dom";
// import { SideBar } from "./SideBar";
import "./navbar.css";
import { title } from "process";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { MdNotificationImportant, MdSettings } from "react-icons/md";
import {
  GET_READ_SYSTEM_NOTICES,
  GET_SYSTEM_NOTICES,
  QUERY_SYSTEM_NOTICES,
} from "../graphql/systemNotice/query";
import { BsAlarm } from "react-icons/bs";
import AdvertisingComponent from "../components/AdvertisingComponent";
import main_logo from "../image/logo_main.png"
import { menuLive, menuSalePage, menusFull } from "../constants/MenuMediaScreen";
import { IoIosPricetags } from "react-icons/io";
import { GET_TRANSACTIONS } from "../graphql/wallet/query";
import { ADD_SHOP_ADDRESS_VALIDATE } from "../graphql/shop/shopAddress/mutation";
import { numberFormat } from "../helpers";
import { GET_SETTING_BY_SHOP } from "../graphql/setting/query";
// import { menuFull, menuSalePage, menuLive } from "../constants/MenuMediaScreen"

const versionWeb = require("../../package.json");

const reportCreditsDateFilterChangedEventName = "reportCreditsDateFilterChanged";
const reportCreditsDateFilterStorageKey = (shopId) =>
  `REPORT_CREDITS_DATE_FILTER::SHOP::${shopId ?? ""}`;
const readReportCreditsDateFilter = (shopId) => {
  try {
    const raw = localStorage.getItem(reportCreditsDateFilterStorageKey(shopId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.createdAt_gte || !parsed?.createdAt_lt) return null;
    return { createdAt_gte: parsed.createdAt_gte, createdAt_lt: parsed.createdAt_lt };
  } catch {
    return null;
  }
};

function NavBar(props) {
  const shopPageCookie = Cookies.get("SHOP_PAGE");
  const assignedPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];
  const { history, location } = useReactRouter();
  const { height, width } = useWindowDimensions();
  const [userData, setUserData] = useState({});
  const [sidebar, setSidebar] = useState(false);
  const [systemNotices, setSystemNotices] = useState([]);
  const [totalSystemNotices, setTotalSystemNotices] = useState(0);
  const [readSystemNotices, setReadSystemNotices] = useState([]);
  const [totalReadSystemNotices, setTotalReadSystemNotices] = useState(0);
  const [showAdverModl, setShowAdverModl] = useState(true);
  const [totalNoClaims, setTotalNoClaims] = useState(0)

  const handleCloseAdverModl = () => setShowAdverModl(false);
  const handleShowAdverModl = () => setShowAdverModl(true);
  const [isProfile, setIsProfile] = useState(false)
  const parentDivRef = useRef(null);


  const _headTitle = localStorage.getItem("headTitle");

  const [titles, setTitles] = useState(_headTitle ?? "");
  const [shopLocalData, setShopLocalData] = useState();
  const [showModal, setShowModal] = useState(false);
  const [getShop, { data: shopDataQ }] = useLazyQuery(SHOP);
  const [connectShopPage] = useMutation(CONNECT_SHOP_PAGE);
  const [fbUserAccessToken, setFbUserAccessToken] = useState("");
  const [shopSetted, setShopSetted] = useState()

  const [showErrorPermissionModal, setShowErrorPermissionModal] =
    useState(false);

  const [fbUserData, setFbUserData, setFbUserDataRef] = useStateRef({});

  const [showPopover, setShowPopover] = useState(false);
  const [menus, setMenus] = useState([])
  const target = useRef(null);

  const { addToast } = useToasts();

  const [getSystemNotices, { data: systemNoticeData, loading: noticeLoading }] =
    useLazyQuery(GET_SYSTEM_NOTICES, {
      fetchPolicy: "network-only",
    });

  const [getReadSystemNotices, { data: readSystemNoticeData }] = useLazyQuery(
    GET_READ_SYSTEM_NOTICES,
    {
      fetchPolicy: "network-only",
    }
  );

  const [getAllTransactions, { data: transactionData, loading: loadingTransaction }] = useLazyQuery(GET_TRANSACTIONS, { fetchPolicy: "network-only" });

  const {
    // fbUserAccessToken,
    // connectFacebook,
    // assignedPageList,
    // logOutOfFB,
  } = useStore();

  const logOutOfFB = useCallback(() => {
    // Warning: If user refresh browser, we cannot use FB.logout.
    // So we call the function removeFbdata() first, event FB.logout not success.
    removeFbdata();
    window.FB.logout(() => { });
  }, []);

  const { data, _ } = useSubscription(SUBSCRIPTION_SHOP_CUTPOINT, {
    variables: {
      onShopCutPointShopId: shopLocalData?.id,
    },
  });

  useEffect(() => {
    if (transactionData?.getAllTransactions?.reports) {
      const transactionsWithNullBillStatus = transactionData?.getAllTransactions?.reports?.chartDatas.filter((data) => data?.billStatus === null);
      console.log("transactionsWithNullBillStatus: ",{ transactionsWithNullBillStatus });
      const totalAmountWithNullBillStatus = transactionsWithNullBillStatus.reduce(
        (sum, transaction) => sum + (transaction.amount || 0),
        0
      );
      setTotalNoClaims(totalAmountWithNullBillStatus)
    }
  }, [transactionData?.getAllTransactions?.reports]);

  useEffect(() => {
    if (systemNoticeData) {
      setSystemNotices(systemNoticeData?.systemNotices?.data);
      setTotalSystemNotices(systemNoticeData?.systemNotices?.total);
      setTotalReadSystemNotices(systemNoticeData?.systemNotices?.totalNotice);
    }
  }, [systemNoticeData]);

  // console.log({ systemNoticeData });

  useEffect(() => {
    if (readSystemNoticeData) {
      setReadSystemNotices(readSystemNoticeData?.readSystemNotices?.data);
    }
  }, [readSystemNoticeData]);

  const _checkReadSystemNotice = (noticeId) => {
    try {
      const _check = readSystemNotices.some((notice) => {
        return notice.systemNotice === noticeId;
      });

      return _check;
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    if (data) {
      let _shopLocalData = shopLocalData;
      _shopLocalData = {
        ..._shopLocalData,
        point: data?.onShopCutPoint?.point,
      };
      setShopLocalData(_shopLocalData);
    }
  }, [data]);

  useEffect(() => {
    initUser();
    _fetchSystemNotices();
    _fetchReadSystemNotices();
    fetchTransactions()

    let _shopSettingData = JSON.parse(localStorage.getItem("SHOP_SETTING_DATA"));
    if (_shopSettingData) {
      // setShopSetted(_shopSettingData?.settingByShopId)
      setShopSetted(_shopSettingData)
    }

  }, []);

  useEffect(() => {
    const onReportCreditsDateFilterChanged = () => {
      fetchTransactions();
    };

    const onStorageChanged = (event) => {
      const shopId = localStorage.getItem("SHOP");
      if (!shopId) return;
      if (event?.key !== reportCreditsDateFilterStorageKey(shopId)) return;
      fetchTransactions();
    };

    window.addEventListener(reportCreditsDateFilterChangedEventName, onReportCreditsDateFilterChanged);
    window.addEventListener("storage", onStorageChanged);

    return () => {
      window.removeEventListener(reportCreditsDateFilterChangedEventName, onReportCreditsDateFilterChanged);
      window.removeEventListener("storage", onStorageChanged);
    };
  }, []);

  useEffect(() => {
    // Event listener for clicks outside the parent div
    const handleClickOutside = (event) => {
      if (
        parentDivRef.current &&
        !parentDivRef.current.contains(event.target)
      ) {
        setIsProfile(false);
      }
    };

    // Attach the event listener to the document body
    document.body.addEventListener("click", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // get credit datas
  const fetchTransactions = async () => {
    try {
      let shopId = localStorage.getItem("SHOP");
      const storedFilter = readReportCreditsDateFilter(shopId);
      const fallbackDate = moment().format("YYYY-MM-DD");

      if (loadingTransaction) return;
      let _where = {
        shopId: shopId, // "657fbca4741fcb028ebeec3f",
        status: "PAYMENT_COMPLETED",
        createdAt_gte: storedFilter?.createdAt_gte ?? fallbackDate,
        createdAt_lt: storedFilter?.createdAt_lt ?? fallbackDate,
      }

      await getAllTransactions({
        variables: {
          where: _where,
        },
      });

    } catch (error) {
      console.log(error);
    }
  };

  const _fetchSystemNotices = async () => {
    try {
      const shop = await localStorage.getItem("SHOP");
      await getSystemNotices({
        variables: {
          where: {
            isDeleted: false,
            status: true,
            shop: shop,
          },
          orderBy: null,
          skip: null,
          limit: null,
        },
      });
    } catch (error) {
      console.log({ error });
    }
  };
  const _fetchReadSystemNotices = async () => {
    try {
      const shop = await localStorage.getItem("SHOP");
      await getReadSystemNotices({
        variables: {
          where: {
            shop,
          },
          orderBy: null,
          skip: null,
          limit: null,
        },
      });
    } catch (error) {
      console.log({ error });
    }
  };

  const initUser = async () => {
    const user = await localStorage.getItem("USER_DATA");
    const shop = await localStorage.getItem("SHOP_DATA");
    if (user) setUserData(JSON.parse(user));
    if (shop) {
      let _parseShop = JSON.parse(shop);
      await getShop({
        variables: {
          where: {
            id: _parseShop?.id,
          },
        },
      });
    }
  };

  useEffect(() => {
    if (shopDataQ) setShopLocalData(shopDataQ.shop);
  }, [shopDataQ]);

  const _onLogout = () => {
    // clear all local storage and cookies
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });
    history.push(`/`);
  };

  //Function
  const showSidebar = () => setSidebar(!sidebar);

  const _onDetailProfile = () => {
    history.push(`/pagenumber/${1}/profile/${userData.id}`);
  };
  const [checkBill, setcheckBill] = useState();

  const _goToHelpCenter = () => {
    window.open("/help-center", "_blank");
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: contactAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (target.current && !target.current.contains(event.target)) {
        setShowPopover(false);
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [target]);

  // Fetches user pages
  useEffect(() => {
    if (fbUserAccessToken) {
      window.FB.api(
        `/me/accounts?access_token=${fbUserAccessToken}`,
        async ({ data }) => {
          window.FB.api(
            `/me?access_token=${fbUserAccessToken}`,
            async (userData) => {
              let _newData = [
                // {
                //   access_token: fbUserAccessToken,
                //   name: userData.name + " (ສ່ວນຕົວ)",
                //   id: userData.id,
                //   isPrivate: true,
                // },
                ...data,
              ];

              localStorage.setItem("SHOP_PAGE", JSON.stringify(_newData));
              // Set a cookie
              Cookies.set("SHOP_PAGE", JSON.stringify(_newData), {
                expires: 3,
              }); // Expires in 1 day
              updateFbFeedList({ assignedPageList: _newData });

              // Save each page's access token straight to the shop's DB record right here —
              // no separate trip through Settings needed, and each page is upserted on its
              // own so it can never wipe another page's already-working token.
              const shopId = localStorage.getItem("SHOP");
              if (shopId) {
                _newData.forEach((page) => {
                  if (!page?.id || !page?.access_token) return;
                  connectShopPage({
                    variables: {
                      where: { id: shopId },
                      pageId: String(page.id),
                      name: page.name || "",
                      token: page.access_token,
                    },
                  }).catch((err) => console.log("connectShopPage error:", err));
                });
              }
            }
          );
        }
      );
    }
  }, [fbUserAccessToken]);

  const connectFB = () => {
    console.log("connectFB");
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          let hasPermission = true;
          [
            "public_profile",
            "email",
            "pages_read_engagement",
            "pages_show_list",
            "pages_messaging",
            "pages_manage_metadata",
            "pages_read_user_content",
          ].map((_permisision) => {
            if (!response.authResponse.grantedScopes.includes(_permisision))
              hasPermission = false;
          });
          if (!hasPermission) {
            addToast("ທ່ານຕ້ອງເປີດອະນຸຍາດໃຫ້ເຂົ້າເຖິງຂໍ້ມູນບໍ່ຄົບຖ້ວນ", {
              appearance: "error",
              autoDismiss: true,
            });
            setShowErrorPermissionModal(true);
            return;
          }
          setFbUserAccessToken(response.authResponse.accessToken);
          // Update redux store
          updateFbdata({
            fbUserAccessToken: response.authResponse.accessToken,
          });

          addToast("ເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກສໍາເລັດ", {
            appearance: "success",
            autoDismiss: true,
          });
        } else
          errorTitleWithTextSwal(
            "ມີຂໍ້ຜິດພາດ",
            "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ"
          );
      },
      {
        scope: `public_profile,email,
                       pages_show_list,
                       pages_read_engagement,
                       pages_messaging,
                       pages_manage_metadata,
                       pages_read_user_content`,
        return_scopes: true,
        auth_type: "rerequest",
      }
    );
  };

  const _gotoOtherPage = (item) => {
    history.push(item.path);
    setTitles(item.title);
    localStorage.setItem("headTitle", item.title);
  };

  const handleClickSystemNotice = (e, systemNotice) => {
    e.stopPropagation();
    history.push("/notice/" + systemNotice?.id, systemNotice);
  };

  const popNoti = {
    position: "absolute",
    top: -4,
    left: 16,
    width: 20,
    height: 20,
    fontSize: 12,
    borderRadius: "50%",
    background: "red",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body style={{ padding: 0 }}>
        {systemNotices?.map((systemNotice, index) => {
          return (
            <div
              key={index}
              className="d-flex"
              style={{
                background:
                  !_checkReadSystemNotice(systemNotice?.id) && "#EEE",
                cursor: "pointer",
                padding: 8,
              }}
              onClick={(e) => handleClickSystemNotice(e, systemNotice)}
            >
              <img
                src={
                  S3_URL +
                  (systemNotice?.details?.length > 0 &&
                    systemNotice?.details[0]?.images?.length > 0 &&
                    systemNotice?.details[0]?.images[0])
                }
                alt=""
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 10,
                  marginRight: 10,
                  marginLeft: 10,
                  objectFit: "cover",
                }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "#000",
                    fontWeight: "bold",
                    fontSize: 18,
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    width: "100%",
                  }}
                >
                  {systemNotice?.title}
                </div>
                {/* <div
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#374151',
                    fontSize: 14,
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    width: '100%',
                  }}>{systemNotice?.details?.length > 0 && (
                    <div style={{fontSize: 10}}><p dangerouslySetInnerHTML={{ __html: systemNotice?.details[0]?.title }} /></div> 
                    )}</div> */}
              </div>
            </div>
          );
        })}
      </Popover.Body>
    </Popover>
  );

  return (
    <div>
      {width > 700 ? (
        <div
          className="NavBar"
          style={{
            boxShadow: "3px 0px 3px rgba(0, 0, 0, 0.16)",
            color: "grey",
            width: "100%",
            position: "fixed",
            zIndex: 2,
            marginLeft: 60,
            paddingRight: 80,
            alignItems: "center",
          }}
        >
          <div className="NavBar_Left">
            <p className="number-version">ເວິຊັ່ນ: {versionWeb?.version}</p>

          </div>
          <div className="NavBar_Right">
            <OverlayTrigger
              show={showPopover}
              trigger="click"
              placement="bottom"
              overlay={popover}
              className="overlay-button"
              target={target.current}
            >
              <div
                ref={target}
                onClick={() => setShowPopover(!showPopover)}
                style={{
                  position: "relative",
                  cursor: "pointer",
                  marginTop: ".6em",
                  marginRight: "2em",
                }}
              >
                <MdNotificationImportant size={25} className="mx-3" />
                <span style={{ marginLeft: "-.3em" }}>ແຈ້ງການ</span>
                {totalReadSystemNotices > 0 && (
                  <span style={popNoti}>{totalReadSystemNotices}</span>
                )}
              </div>
            </OverlayTrigger>

            {/* //TODO Check isPaymentGateway and useSalePage  */}
            {(transactionData && shopSetted?.isPaymentGateway || 
              (shopSetted?.shop?.systems ? shopSetted?.shop?.systems.includes("SALE_PAGE") : false)
              ) && <Button onClick={() => history.push("/wallet_store/limit/50/page/1")} style={{ maxHeight: 40, margin: "2px 7px" }} size="small" variant="outline-success">
              ເຄຣດິດ: {numberFormat(totalNoClaims ?? 0)} ກີບ
            </Button>}

            {props.fbdata.fbUserAccessToken ? (
              <button
                onClick={logOutOfFB}
                className="Facebook_Button_Logout"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "transparent",
                  color: COLOR_TEXT,
                  borderColor: COLOR_TEXT,
                }}
              >
                <FontAwesomeIcon
                  icon={faRightFromBracket}
                  style={{ marginRight: 5 }}
                />
                ຍົກເລີກການເຊື່ອມຕໍ່
              </button>
            ) : (
              <button
                id="connect_fb"
                onClick={() => connectFB()}
                className="Facebook_Button"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "none",
                  // background: COLOR_APP,
                }}
              >
                <FontAwesomeIcon icon={faFacebook} style={{ marginRight: 5 }} />
                {width > 700 && "ເຊື່ອມຕໍ່ກັບ"} Facebook
              </button>
            )}

            <div className="User_Detail">

              <p>{shopLocalData?.name}</p>
              <div style={{ width: 38, height: 38, cursor: 'pointer', border: '1px solid #ddd', borderRadius: 3 }} onClick={(e) => setIsProfile(!isProfile)}>
                {shopLocalData?.image?.length ? (
                  <img className="w-100 h-100" src={S3_URL + shopLocalData?.image} alt="profile_shop" />
                ) : (
                  <FontAwesomeIcon
                    icon={faCircleUser}
                    style={{ fontSize: "30px" }}
                  />
                )}
              </div>
            </div>

            {isProfile &&
              <div className="card-profile-account" ref={parentDivRef} >

                <div className="menu-setting" onClick={() => setIsProfile(false)}>
                  <li onClick={() => history.push("/settings-profile")}>
                    <FaRegUserCircle style={{ fontSize: 18, marginRight: 10 }} />
                    ໂປຣຟາຍຮ້ານ</li>
                  <li onClick={() => history.push("/settings")}>
                    <MdSettings style={{ fontSize: 23, marginRight: 10 }} />
                    ຕັ້ງຄ່າ</li>
                  <li onClick={() => {
                    window.open(WEB_LANDING_PAGE_URL + "/#pricing")
                  }}>
                    <IoIosPricetags style={{ fontSize: 18, marginRight: 10 }} />
                    ລາຄາແພັກເກັດ</li>
                  <li onClick={() => _goToHelpCenter()}>
                    <FaIcons.FaHeadset style={{ fontSize: 18, marginRight: 10 }} />
                    ສູນຊ່ວຍເຫລືອ</li>
                  <li onClick={() => _onLogout()}>
                    <FaPowerOff style={{ fontSize: 18, marginRight: 10 }} />
                    ອອກຈາກລະບົບ</li>
                </div>
              </div>
            }

          </div>
        </div>
      ) : (
        <Card style={{ background: COLOR_APP, height: "100%" }}>
          <div className="fixed-navbar">
            <IconContext.Provider value={{ color: "#252A31" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: 'center', width: '100%'
                }}
              >
                <div>
                  <Button onClick={() => setSidebar(true)} variant="light">
                    <FaIcons.FaBars />
                  </Button>
                  <span style={{ color: "#252A31" }}>
                    {titles ? titles : "Super CF"}
                  </span>
                </div>
                <div className="d-flex">
                  <OverlayTrigger
                    show={showPopover}
                    trigger="click"
                    placement="bottom"
                    overlay={popover}
                    target={target.current}
                  >
                    <div
                      ref={target}
                      onClick={() => setShowPopover(!showPopover)}
                      // onClick={handleShowAdverModl}
                      style={{
                        position: "relative",
                        cursor: "pointer",
                        marginTop: 2,
                        marginRight: 5
                      }}
                    >
                      <MdNotificationImportant size={25} color="red" className="mx-3" />
                      {totalReadSystemNotices > 0 && (
                        <span style={popNoti}>
                          {totalReadSystemNotices}
                        </span>
                      )}
                    </div>
                  </OverlayTrigger>
                  <div>
                    {props.fbdata.fbUserAccessToken ? (
                      <Button
                        onClick={logOutOfFB}
                        className="Facebook_Button_Logout mr-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "transparent",
                          borderColor: COLOR_TEXT,
                          color: COLOR_TEXT,
                          fontSize: 12,
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faRightFromBracket}
                          style={{ marginRight: 5 }}
                        />
                        ຍົກເລີກການເຊື່ອມຕໍ່
                      </Button>
                    ) : (
                      <Button
                        id="connect_fb"
                        onClick={() => connectFB()}
                        className="Facebook_Button mr-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: COLOR_APP,
                          color: "#FFF",
                          border: "none",
                          fontSize: 12,
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faFacebook}
                          style={{ marginRight: 5 }}
                        />
                        Facebook
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </IconContext.Provider>
          </div>
        </Card>
      )}
      {/* 
      {width < 700 && (
        <div className="app-bar-mobile">

          <button className="btn-home-live"><FaIcons.FaVideo style={{fontSize: 28}} /></button>

        </div>
      )} */}

      <Offcanvas
        show={sidebar}
        style={{ color: COLOR_WHITE, width: 280 }}
        onHide={() => setSidebar(false)}
      >
        <Offcanvas.Header closeButton style={{ background: COLOR_APP, position: 'relative' }}>
          <img src={main_logo} style={{ maxWidth: 40, borderRadius: 10, marginRight: 20 }} />
          <Offcanvas.Title style={{ color: COLOR_WHITE, paddingTop: 10 }}>
            <h1 style={{ fontSize: 24, fontWeight: 'bold', marginLeft: '-.5em' }}>Super CF</h1>
          </Offcanvas.Title>
          <p style={{ position: 'absolute', bottom: "-1.5em", right: 8, fontSize: 10 }}>{versionWeb?.version}</p>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {menusFull.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => setSidebar(false)}
                style={{
                  justifyContent: "space-between",
                  padding: 5
                }}
              >
                <li
                  className={item?.cName}
                  style={{
                    margin: 0,
                    background:
                      item.path.split("-")[0] ===
                        location.pathname.split("-")[0]
                        ? "#f2f2f2"
                        : "#ffffff",
                    color:
                      item.path.split("-")[0] ===
                        location.pathname.split("-")[0]
                        ? "#cc2000"
                        : COLOR_TEXT,
                    cursor: "pointer",
                  }}
                  onClick={() => _gotoOtherPage(item)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                      alignItems: "center",
                      marginLeft: 10,
                      padding: 5,
                    }}
                  >
                    <div style={{ paddingTop: 2 }}>{item.icon}</div>
                    <span style={{ marginBottom: 5 }}>
                      {item.title}
                    </span>
                  </div>
                </li>
              </div>
            );
          })}
          <div
            className="meu-logout-system"
            onClick={() => _onLogout()}
          >
            <FontAwesomeIcon icon={faPowerOff} />
            <p>ອອກຈາກລະບົບ</p>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {totalReadSystemNotices > 0 && (
        <AdvertisingComponent
          systemNotices={systemNotices}
          noticeLoading={noticeLoading}
          handleCloseAdverModl={handleCloseAdverModl}
          showAdverModl={showAdverModl}
          handleClickSystemNotice={handleClickSystemNotice}
        />
      )}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        keyboard={false}
      >
        <Modal.Header
          style={{
            background: COLOR_APP,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: 50,
            color: "#fff",
          }}
        >
          <h5>ຊ່ອງທາງການຕິດຕໍ່</h5>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <p>4B SHOP ລະບົບດູດໄລຟສົດ</p>
          <p>ເບີໂທ: 020 22667809</p>
          <Lottie options={defaultOptions} width={400} />
          <p style={{ color: COLOR_TEXT, fontWeight: "bold" }}>
            {versionWeb?.version}
          </p>
        </Modal.Body>
      </Modal>

      <ErrorPermissionModal
        showErrorPermissionModal={showErrorPermissionModal}
        setShowErrorPermissionModal={setShowErrorPermissionModal}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    fbdata: state.fbdata,
  };
};

export default connect(mapStateToProps)(NavBar);
